import { INTEGRATIONS, integrationAvailable } from './integrations.js';
import { MODULES, PLANS, PLAN_LABELS, modulesForPlan } from './modules.js';
import { STORAGE_PLAN_BYTES } from './storage.js';
/** Module, die nie wegfallen: Benutzer, Rollen und Einrichtung gehören zu jedem Paket */
const ALWAYS = new Set(['users', 'setup']);
/** Schlüssel der Module, die mit dem Wechsel wegfallen (umgesetzt, ohne Benutzer und Einrichtung, ohne gebuchte Zusatzmodule) */
export function lostModuleKeys(from, to, addons = []) {
    const after = new Set(modulesForPlan(to));
    return modulesForPlan(from).filter((k) => !after.has(k) && !addons.includes(k) && !ALWAYS.has(k) && MODULES.find((m) => m.key === k)?.available === true);
}
/**
 * Was ändert sich, wenn ein Mandant vom Paket `from` auf `to` wechselt? Nur umgesetzte Module zählen (kein „in Vorbereitung“). Gebuchte Zusatzmodule
 * bleiben bestehen und tauchen deshalb weder bei den dazukommenden noch bei den wegfallenden auf.
 */
export function planChange(from, to, addons = []) {
    const before = new Set(modulesForPlan(from));
    const after = new Set(modulesForPlan(to));
    const label = (key) => MODULES.find((m) => m.key === key)?.label ?? key;
    const real = (key) => !ALWAYS.has(key) && MODULES.find((m) => m.key === key)?.available === true;
    const lost = [...before].filter((k) => !after.has(k) && !addons.includes(k) && real(k)).map(label);
    const gained = [...after].filter((k) => !before.has(k) && !addons.includes(k) && real(k)).map(label);
    const lostIntegrations = INTEGRATIONS.filter((i) => integrationAvailable(from, i.key) && !integrationAvailable(to, i.key)).map((i) => i.label);
    const direction = PLANS.indexOf(to) > PLANS.indexOf(from) ? 'up' : PLANS.indexOf(to) < PLANS.indexOf(from) ? 'down' : 'same';
    return { direction, gained, lost, lostIntegrations, storageFromBytes: STORAGE_PLAN_BYTES[from], storageToBytes: STORAGE_PLAN_BYTES[to] };
}
const gb = (bytes) => `${Math.round(bytes / 1024 ** 3)} GB`;
const list = (items) => items.join(', ');
/** Text für das Info-Symbol neben „Herunterstufen“: was Sie mit dem kleineren Paket verlieren */
export function downgradeText(from, to, addons = []) {
    const c = planChange(from, to, addons);
    const parts = [];
    if (c.lost.length)
        parts.push(`Diese Bereiche stehen nicht mehr zur Verfügung: ${list(c.lost)}.`);
    if (c.lostIntegrations.length)
        parts.push(`Diese Verbindungen entfallen: ${list(c.lostIntegrations)}.`);
    if (c.storageToBytes < c.storageFromBytes)
        parts.push(`Der Speicher im Paket sinkt von ${gb(c.storageFromBytes)} auf ${gb(c.storageToBytes)}.`);
    parts.push('Bereiche, die nicht mehr im Paket sind, lassen sich danach weder öffnen noch bearbeiten.');
    return `Beim Wechsel auf ${PLAN_LABELS[to]}: ${parts.join(' ')}`;
}
/** Text für das Info-Symbol neben „Buchen“: was mit dem größeren Paket dazukommt */
export function upgradeText(from, to, addons = []) {
    const c = planChange(from, to, addons);
    const parts = [];
    if (c.gained.length)
        parts.push(`Neu: ${list(c.gained)}.`);
    if (c.storageToBytes > c.storageFromBytes)
        parts.push(`Der Speicher im Paket wächst von ${gb(c.storageFromBytes)} auf ${gb(c.storageToBytes)}.`);
    return `Mit ${PLAN_LABELS[to]}: ${parts.join(' ')}`;
}
//# sourceMappingURL=plan-change.js.map